import { getType } from 'typesafe-actions';
import { NotificationType, SignalRNotificationType, NotificationStatus } from '../../types';
import { NotificationActions, notificationActions } from '../creators';

export type NotificationsState = NotificationType[] | null;

const mapSignalRToNotificationType = (notification: SignalRNotificationType) => ({
  ...notification,
  status: notification.status === 0 ? NotificationStatus.New : NotificationStatus.Read,
});

export const notificationsReducer = (state: NotificationsState = null, action: NotificationActions) => {
  switch (action.type) {
    case getType(notificationActions.getNotificationsRequest.success):
      return action.payload.map((notification) => ({ ...notification, timeStamp: new Date(notification.timeStamp) }));

    case getType(notificationActions.addNotification):
      return state
        ? [mapSignalRToNotificationType(action.payload), ...state]
        : [mapSignalRToNotificationType(action.payload)];

    case getType(notificationActions.markNotificationAsReadRequest.success):
      return state
        ? state.map((notification) => {
            if (notification.notificationId === action.payload.notificationId) {
              return action.payload;
            }

            return notification;
          })
        : state;

    default:
      return state;
  }
};
